import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box, Chip
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { CreateTerminalSchema } from '../schemes/CreiacaoDeTerminais';
import { FormatarDinherio } from '../helpers/FormatarBrl';
import { EditProdutoSchema } from '../schemes/EdicaoDeProdutos';

const StatusChip = ({ status }) => {
    const statusConfig = {
        S: { label: 'Ativo', color: 'success' },
        N: { label: 'Inativo', color: 'error' },
    };

    const config = statusConfig[status] || { label: 'Não informado', color: 'default' };

    return <Chip label={config.label} color={config.color} size="small" />;
};

export default function ModalEdicao({ open, onClose, onSave, produto, isLoading, grupos, sub_grupos }) {

    const [filtros, setFiltros] = useState({
        nome: '',
        valor: '',
        status: '',
        cod_produto: 0,
        cod_grupo: 0,
        cod_subgrupo: 0,
        cod_consulta: 0,
    });

    const [erroNomeProduto, seterroNomeProduto] = useState(false);
    const [erroNomeProdutoMessage, seterroNomeProdutoMessage] = useState('');

    const [erroValorProduto, seterroValorProduto] = useState(false);
    const [erroValorProdutoMessage, seterroValorProdutoMessage] = useState('');



    useEffect(() => {
        if (produto) {
            setFiltros({
                nome: produto.nome,
                valor: FormatarDinherio(produto.valor),
                status: produto.status,
                cod_produto: produto.cod_produto,
                cod_grupo: produto.cod_do_grupo,
                cod_subgrupo: produto.cod_subgrupo,
                cod_consulta: produto.cod_consulta,
            });
        }
    }, [produto]);


    const handleChange = (e) => {
        let { name, value } = e.target;

        if (name === 'valor') {
            let somenteNumeros = value.replace(/\D/g, '');
            let numero = parseFloat(somenteNumeros) / 100;
            let valor_formatado = FormatarDinherio(numero);
            setFiltros(prev => ({ ...prev, [name]: valor_formatado }));
        } else {
            setFiltros(prev => ({ ...prev, [name]: value }));
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        let nome = filtros.nome;
        let valor = filtros.valor;
        let status = filtros.status;

        const result = EditProdutoSchema.safeParse({ nome, valor, status });

        if (!result.success) {
            const errors = result.error.format();

            if (errors.nome?._errors?.length) {
                seterroNomeProduto(true);
                seterroNomeProdutoMessage(errors.nome._errors[0]);
            } else {
                seterroNomeProduto(false);
                seterroNomeProdutoMessage('');
            }

            if (errors.valor?._errors?.length) {
                seterroValorProduto(true);
                seterroValorProdutoMessage(errors.valor._errors[0]);
            } else {
                seterroValorProduto(false);
                seterroValorProdutoMessage('');
            }
            return;
        }

        onSave(filtros);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Editar Produto</DialogTitle>
            <Box
                component="form"
                onSubmit={handleSubmit}
            >
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
                            <TextField
                                fullWidth
                                name="cod_produto"
                                value={filtros.cod_produto}
                                onChange={handleChange}
                                label='Código do produto'
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}

                            />
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
                            <TextField
                                fullWidth
                                name="cod_consulta"
                                value={filtros.cod_consulta}
                                onChange={handleChange}
                                label='Código de consulta'
                                variant="outlined"
                                InputProps={{
                                    readOnly: true,
                                    sx: { backgroundColor: 'white', color: 'black' }
                                }}
                                InputLabelProps={{
                                    sx: { bgcolor: 'white', px: 0.5, color: 'black' }
                                }}
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                fullWidth
                                name="nome"
                                value={filtros.nome}
                                onChange={handleChange}
                                label='Nome do produto'
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                error={erroNomeProduto}
                                helperText={erroNomeProdutoMessage}
                                required
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                type='text'
                                fullWidth
                                name="valor"
                                value={filtros.valor}
                                onChange={handleChange}
                                label='Valor do produto'
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                error={erroValorProduto}
                                helperText={erroValorProdutoMessage}
                                required
                            />
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                label="Grupo"
                                name="cod_grupo"
                                value={filtros.cod_grupo}
                                onChange={handleChange}
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}

                            >
                                {grupos.map((grup) => {
                                    return (
                                        <MenuItem
                                            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                            value={grup.cod_grupo}
                                        >
                                            {grup?.nome || "Não informado"} <StatusChip status={grup.online} />

                                        </MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                label="Sub grupo"
                                name="cod_subgrupo"
                                value={filtros.cod_subgrupo}
                                onChange={handleChange}
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                            >
                                {sub_grupos.map((sub) => {
                                    return (
                                        <MenuItem
                                            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                            value={sub.cod_subgrupo}
                                        >
                                            {sub?.nome || "Não informado"} <StatusChip status={sub.online} />

                                        </MenuItem>
                                    )
                                })}
                            </TextField>
                        </Grid>
                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                label="Ativo"
                                name="status"
                                value={filtros.status}
                                onChange={handleChange}
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                required
                            >
                                <MenuItem value='S'>{'Sim'}</MenuItem>
                                <MenuItem value='N'>{'Não'}</MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">Cancelar</Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                        disabled={isLoading}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}